import styled from 'styled-components';

const TitleMLStyled = styled.div`
  margin-bottom: 32px;
  .title-style {
    color: #333333;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
    font-family: SourceHanSansCN;
    font-weight: 600;
    line-height: 1;
  }
`;
export default TitleMLStyled;
